export default {"src":"/_next/static/media/reviews-icon.ede309d4.svg","height":31,"width":54};